var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH2HPinActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4854 3.51474C22.6885 5.71758 23.9485 8.6909 23.999 11.806C24.0496 14.921 22.8866 17.9336 20.7561 20.2067L20.4854 20.4867L14.8281 26.1427C14.1102 26.8601 13.1466 27.2778 12.1323 27.3112C11.118 27.3447 10.1289 26.9913 9.36541 26.3227L9.17341 26.1427L3.51474 20.4854C1.26429 18.235 0 15.1827 0 12.0001C0 8.81746 1.26429 5.76519 3.51474 3.51474C5.76519 1.26429 8.81746 0 12.0001 0C15.1827 0 18.235 1.26429 20.4854 3.51474Z",
    fill: "#EE4360"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 11.5) scale(0.6) translate(-15.251 -14.7085)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5101 15.5581C13.5101 15.5581 13.5708 19.9839 10.1756 20.1796C6.78094 20.3739 4.6582 16.7949 4.6582 16.7949C4.6582 16.7949 13.0859 15.8843 13.5101 15.5581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.03 11C25.03 11 17.0277 11.3907 13.5109 11C13.5109 11 16.3003 18.6142 11.0254 20.826C11.0254 20.826 14.1782 21.2174 16.9068 20.826C19.6348 20.4353 25.6979 18.9397 25.03 11Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2HPinActive);
export default __webpack_public_path__ + "static/media/h2h-pin-active.a8aee81cd4b7c80291e17caa5b13fbd9.svg";
export { ForwardRef as ReactComponent };